export const TASKS_ENDPOINT = 'winter-service-tasks'

// The streets (trase) of a task always hang under it - the backend has no route
// that reaches one without its task.
export const buildTaskStreetsEndpoint = (taskId) => `${TASKS_ENDPOINT}/${taskId}/streets`

// The streets of several tasks at once, for the listing's side map. A POST rather than
// a GET: the whole picked selection is sent as a list, and the listing can show every
// task at once - too much for a query string.
export const TASKS_STREETS_ENDPOINT = `${TASKS_ENDPOINT}/streets`
// Tasks as a picker: id and name only, for the filters that narrow a listing to one task.
export const TASKS_AUTOCOMPLETE_ENDPOINT = `${TASKS_ENDPOINT}/autocomplete`

// Turning tasks into incoming requests. One call takes every picked task at once.
export const TASKS_TO_REQUESTS_ENDPOINT = `${TASKS_ENDPOINT}/incoming-requests`

// The city districts a street can sit in. The street keeps the district's name rather
// than a link to it, which is why the field is bound to `name` - see TaskStreetDialog.
export const CITY_DISTRICTS_AUTOCOMPLETE_ENDPOINT = 'traffic-regulation/city-districts'

// The listing offers `All` on top of the usual choices (-1 is what the table's
// pagination reads as every record on one page): the routes of every task can be
// looked at on the map at once, which means being able to tick them all.
export const TASKS_ALL_RECORDS_PER_PAGE = -1
export const TASKS_PER_PAGE_OPTIONS = [20, 50, 100, TASKS_ALL_RECORDS_PER_PAGE]

export const TASKS_TABLE_KEY = 'winter-service-v2-tasks'
export const TASKS_UI_VIEW = 'winter_service2_tasks'

export const TASK_STREETS_TABLE_KEY = 'winter-service-v2-task-streets'

export const TASKS_INDEX_ROUTE = 'WinterService2Tasks'
export const TASK_DETAILS_ROUTE = 'WinterService2TaskDetails'
export const TASK_CREATE_ROUTE = 'WinterService2TaskCreate'

export const TASKS_TRANSLATION_NAMESPACE = 'road-maintenance/winter_service2/tasks'

// The tab keys are what TabsLayout locks tabs by, so they have to be stable and
// distinct - see useTaskDetails for the warning that lock drives.
export const TASK_BASIC_INFO_TAB_KEY = 'task_basic_information'
export const TASK_STREETS_TAB_KEY = 'task_streets'

// The codebook types the basic information tab picks from. The road maintenance
// `codebook` endpoint answers keyed by the lowercased type name, which is what
// `useTaskCodebooks` reads them back off.
export const TASK_CODEBOOK_TYPES = [
  'WS_TASK_TYPE',
  'WS_TASK_CATEGORY',
  'ROADWAY_SIDEWALK_TYPE',
  'WS_CLEANING_TYPE',
  'WS_SPREAD_TYPE',
  'WS_PATH_TYPE'
]

// How a task street was drawn. A polygon and a circle are areas rather than routes:
// neither has a length, width, passes or road type - the backend refuses them - so the
// street form hides those for both. A circle is the one shape its points do not
// describe on their own: `path` holds its centre and `radius` the rest of it.
export const PATH_TYPE = {
  polyline: 'POLYLINE',
  polygon: 'POLYGON',
  circle: 'CIRCLE'
}

// How a street is driven. It decides how its passes are split between the two
// directions, which is what coverage is counted against - a one-way street asks for all
// of them in the direction it is drawn in, a two-way one for half in each.
export const DIRECTION_MODE = {
  one_way: 'one_way',
  two_way: 'two_way'
}

// The colour the task's own routes are drawn in, on both the listing map and the
// route tab - the same green the rest of the winter service maps use.
export const STREET_PATH_COLOR = '#65AD45'
